import { Injectable } from '@angular/core';

declare let gtag: Function;

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {

  constructor() {}

  public sendEvent(
    eventName: string,
    eventCategory: string,
    eventLabel: string = '',
    eventValue: number = 0
  ): void {
    if (typeof gtag === 'function') {
      gtag('event', eventName, {
        event_category: eventCategory,
        event_label: eventLabel,
        value: eventValue
      });
    } else {
      console.warn('gtag function not available');
    }
  }
}